import React from "react";
import ManageDefaultRoutes from "../../ManageDefaultRoutes";
import Dashboard from "../../../pages/Operational/Academic/Dashboard/Index";
import Students from "../../../pages/Operational/Academic/Students/Index";
import Teachers from "../../../pages/Operational/Academic/Teachers/Index";
import Events from "../../../pages/Operational/Academic/Events/Index";
import { Route } from "react-router-dom";
import Attendence from "../../../pages/Operational/Academic/Attendence/Index";
import StudentsProfile from "../../../pages/Operational/Academic/StudentsProfile/Index";
import Programs from "../../../pages/Operational/Academic/Programs/Index";
import ProgramDetails from "../../../pages/Operational/Academic/ProgramDetails/Index";
import Admission from "../../../pages/Operational/Academic/Admission/Index";
import ExamOverview from "../../../pages/Operational/Academic/Exams/ExamOverview/Index";
import ExamDetails from "../../../pages/Operational/Academic/Exams/ExamDetails/Index";
import ExamResult from "../../../pages/Operational/Academic/Exams/ExamResult/Index";

const AcademicsRoutes = (
  <>
    <Route path="academic/*">
      <Route index element={<ManageDefaultRoutes path="dashboard" />} />
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="attendence" element={<Attendence />} />

      <Route path="students/*">
        <Route index element={<Students />} />
        <Route path="profile" element={<StudentsProfile />} />
      </Route>

      <Route path="teachers" element={<Teachers />} />

     <Route path="exams">
        <Route index element={<ExamOverview />} />
        <Route path="examDetails/:id" element={<ExamDetails />} />
        <Route path="examResult" element={<ExamResult />} />
      </Route>

      <Route path="events" element={<Events />} />

      <Route path="programs/*">
        <Route index element={<Programs />} />
        <Route path="details/:id" element={<ProgramDetails />} />
      </Route>
      <Route path="admission/*">
        <Route index element={<Admission />} />
      </Route>
    </Route>
  </>
);
export default AcademicsRoutes;
